import gql from "graphql-tag";

const providersQuery = gql`
  query providersQuery(
    $search: String
    $isCommercial: Boolean
    $first: Int
  ) {
    providers(name_Icontains: $search, isCommercial: $isCommercial, first: $first) {
      edges{
        node{
          id
          name
        }
      }
    }
  }
`;

export default providersQuery;